<div class="bg-white/30 w-full h-px md:w-0.5 md:h-8 self-center"></div>
<button
  (click)="downloadPdf()"
  [disabled]="download.loading()"
  class="flex items-center gap-2 text-white text-sm md:text-base cursor-pointer disabled:opacity-50 disabled:cursor-wait py-1 md:py-0 pl-1 md:pl-0"
>
  @if (download.loading()) {
    <mat-spinner diameter="20" />
  } @else {
    <mat-icon svgIcon="cp-download" class="text-white !stroke-white !w-4 !h-4" />
  }
  <span class="text-nowrap">Download als PDF</span>
</button>
